import axios from 'axios'

// Parse optional env vars with safe fallbacks to avoid sending NaN/undefined
const timeout = Number(process.env.VUE_APP_TIMEOUT || 10000)
const systemId = Number(process.env.VUE_APP_SYSTEM || 0)

export const tuApptoAPI = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL,
  timeout,
  headers: {
    'x-system': systemId,
  },
})

export const getAuthHeaders = (headers = {}) => ({
  headers: {
    'x-token': sessionStorage.getItem('token'),
    ...headers,
  },
})

export const getErrorData = (error, fallbackMessage = 'Error inesperado') =>
  error?.response?.data || {
    ok: false,
    status: 500,
    message: fallbackMessage,
  }
